import React from "react";
import { Compass, Megaphone, Layers, Repeat } from "lucide-react";

const problems = [
    {
        icon: Compass,
        title: "Losing Motivation",
        body: "Every losing trade makes you question whether trading is for you.",
    },
    {
        icon: Megaphone,
        title: "Following Random Signals",
        body: "Different groups, different influencers, different signals. End up confused — and usually red.",
    },
    {
        icon: Layers,
        title: "Information Overload",
        body: "Too many YouTube videos, too many strategies, too many opinions. Nothing actually sticks.",
    },
    {
        icon: Repeat,
        title: "Repeating The Same Mistakes",
        body: "Same chart, same entry, same loss — without ever understanding what's really going wrong.",
    },
];

const ProblemSection = () => {
    return (
        <section
            id="problem"
            data-testid="problem-section"
            className="bg-[#F2F2F2] py-20 md:py-28"
        >
            <div className="px-6 md:px-12 lg:px-24">
                <div className="max-w-3xl">
                    <span
                        data-testid="problem-eyebrow"
                        className="inline-block text-xs sm:text-sm font-semibold tracking-widest uppercase text-[#0077b6]"
                    >
                        The Struggle Is Real
                    </span>
                    <h2
                        data-testid="problem-heading"
                        className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-black"
                    >
                        Does this sound familiar, bro?
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">
                        Most new traders in Malaysia and Singapore aren't
                        failing because they lack effort — they're failing
                        because they're alone, copying random people, and
                        repeating the same painful loop every week.
                    </p>
                </div>

                <div
                    data-testid="problem-grid"
                    className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6"
                >
                    {problems.map((p, i) => (
                        <div
                            key={p.title}
                            className="group relative"
                        >
                            {/* Blooming glow outside the border */}
                            <div
                                aria-hidden="true"
                                className="pointer-events-none absolute -inset-1 rounded-3xl bg-gradient-to-br from-[#0077b6] via-[#3aa6e0] to-[#0077b6] opacity-20 blur-xl group-hover:opacity-60 group-hover:blur-2xl transition-all duration-500"
                            />
                            <div
                                data-testid={`problem-card-${i}`}
                                className="relative h-full bg-white rounded-2xl p-7 border border-gray-200/70 shadow-sm group-hover:shadow-xl group-hover:-translate-y-1 transition-all duration-300"
                            >
                                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#0077b6]/10 text-[#0077b6] group-hover:bg-[#0077b6] group-hover:text-white transition-colors">
                                    <p.icon className="h-6 w-6" />
                                </div>
                                <h3 className="font-display mt-5 text-lg sm:text-xl font-semibold text-black tracking-tight">
                                    {p.title}
                                </h3>
                                <p className="mt-2 text-sm sm:text-base text-gray-600 leading-relaxed">
                                    {p.body}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProblemSection;
